<template>
  <div class="orderManagementDetail">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <div class="title" v-if="CLOId">{{ $t.orderManagement.orderDetail }}</div>
      <div class="title" v-else>{{ $t.orderManagement.createOrder }}</div>

      <div v-if="CLOId">
        <div class="custom-field">
          <div class="custom-field-label">{{ $t.orderManagement.cargoCategory }}</div>
          <div class="custom-field-value">
            <span>{{ TransportationService }}</span>
          </div>
        </div>

        <div class="custom-field">
          <div class="custom-field-label">{{ $t.orderManagement.serviceProvider }}</div>
          <div class="custom-field-value">
            <span>{{ LogisticsChannelStr }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <van-field
          clickable
          readonly
          :value="form.fpIdStr"
          :label="$t.meta.country"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showOrderManagementDetailFreight')"
          required
          :rules="formRule"
        />

        <van-field
          clickable
          readonly
          :value="form.fpdIdStr"
          :label="$t.orderManagement.cargoCategory"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showOrderManagementDetailFreightDetail')"
          required
          :rules="formRule"
        />

        <van-field
          clickable
          readonly
          :value="form.TaxFeebearingPartyStr"
          :label="$t.orderManagement.taxFeebearingParty"
          :placeholder="$t.meta.select"
          @click="pickerShow('showTaxFeePicker')"
          required
          :rules="formRule"
        />

        <van-field
          clickable
          readonly
          :value="form.PTIdStr"
          :label="$t.orderManagement.productCategory"
          :placeholder="$t.meta.select"
          @click="pickerShow('showProductCategoryPicker')"
          required
          :rules="formRule"
          v-if="productTaxList.length > 0"
        />
      </div>

      <!-- Naqel -->
      <div v-if="LogisticsChannel == 1">
        <div class="custom-date">
          <div class="date-btn1">
            <div class="date-require">*</div>
            {{ $t.orderManagement.naqel_ShippingDateTime }}
          </div>
          <div class="date-btn2" @click="showTimeDate">
            <span v-if="form.Naqel_ShippingDateTime" class="value">{{
              form.Naqel_ShippingDateTime
            }}</span>
            <span v-else class="placeholder">{{ $t.meta.select }}</span>
          </div>
        </div>

        <van-field
          v-model="form.Naqel_DescriptionOfGoods"
          :label="$t.orderManagement.naqel_DescriptionOfGoods"
          :placeholder="!CLOId ? $t.meta.input : ''"
          required
          :disabled="CLOId ? true : false"
        />

        <van-field
          v-model="form.Naqel_NumberOfPieces"
          :label="$t.orderManagement.naqel_NumberOfPieces"
          :placeholder="!CLOId ? $t.meta.input : ''"
          oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          required
          :disabled="CLOId ? true : false"
        />
      </div>
      <!-- iMile -->
      <div v-if="LogisticsChannel == 2">
        <van-field
          v-model="form.iMile_PackageTotalVolume"
          :label="$t.orderManagement.iMile_PackageTotalVolume + '(cm3)'"
          :placeholder="!CLOId ? $t.meta.input : ''"
          oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          required
          :disabled="CLOId ? true : false"
        />

        <van-field
          v-model="form.iMile_PackageGrossWeight"
          :label="$t.orderManagement.iMile_PackageGrossWeight + '(kg)'"
          :placeholder="!CLOId ? $t.meta.input : ''"
          oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          required
          :disabled="CLOId ? true : false"
        />

        <van-field
          v-model="form.iMile_PackageTotalCount"
          :label="$t.orderManagement.iMile_PackageTotalCount"
          :placeholder="!CLOId ? $t.meta.input : ''"
          oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          required
          :disabled="CLOId ? true : false"
        />

        <van-field
          v-model="form.iMile_PackageGoodsType"
          :label="$t.orderManagement.iMile_PackageGoodsType"
          @click="pickerShow('showOrderManagementType')"
          :placeholder="!CLOId ? $t.meta.input : ''"
          clickable
          readonly
          required
        />
      </div>

      <div class="title">{{ $t.orderManagement.shipper }}</div>

      <van-field
        v-model="form.shipperContact.companyName"
        :label="$t.orderManagement.companyName"
        :placeholder="!CLOId ? $t.meta.input : ''"
        :required="LogisticsChannel == 1 ? true : false"
        :rules="LogisticsChannel == 1 ? formRule : null"
        :disabled="CLOId ? true : false"
      />

      <van-field
        v-model="form.shipperContact.contacts"
        :label="$t.orderManagement.contactName"
        :placeholder="!CLOId ? $t.meta.input : ''"
        required
        :rules="formRule"
        :disabled="CLOId ? true : false"
      />

      <van-field
        v-model="form.shipperContact.phoneNumber"
        :label="$t.orderManagement.phoneNumber"
        :placeholder="!CLOId ? $t.meta.input : ''"
        required
        :rules="formRule"
        :disabled="CLOId ? true : false"
      />

      <van-field
        v-model="form.shipperContact.email"
        :label="$t.orderManagement.email"
        :placeholder="!CLOId ? $t.meta.input : ''"
        :required="LogisticsChannel == 1 ? true : false"
        :rules="LogisticsChannel == 1 ? formRule : null"
        :disabled="CLOId ? true : false"
      />

      <van-field
        clickable
        readonly
        :value="form.shipperContact.countryName"
        :label="$t.meta.country"
        :placeholder="!CLOId ? $t.meta.select : ''"
        @click="onShowEmit('showOrderManagementDetailShipperCountry')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="form.shipperContact.cityName"
        :label="$t.meta.city"
        :placeholder="!CLOId ? $t.meta.select : ''"
        @click="onShowEmit('showOrderManagementDetailShipperCity')"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.shipperContact.zipCode"
        :label="$t.orderManagement.zipCode"
        :placeholder="!CLOId ? $t.meta.input : ''"
        required
        :rules="formRule"
        :disabled="CLOId ? true : false"
      />

      <van-field
        v-model="form.shipperContact.address"
        :label="$t.orderManagement.detailAddress"
        :placeholder="!CLOId ? $t.meta.input : ''"
        required
        :rules="formRule"
        type="textarea"
        :disabled="CLOId ? true : false"
      />

      <div class="title">{{ $t.orderManagement.consignee }}</div>

      <van-field
        v-model="form.consigneeContact.companyName"
        :label="$t.orderManagement.companyName"
        :placeholder="!CLOId ? $t.meta.input : ''"
        :disabled="CLOId ? true : false"
      />

      <van-field
        v-model="form.consigneeContact.contacts"
        :label="$t.orderManagement.contactName"
        :placeholder="!CLOId ? $t.meta.input : ''"
        required
        :rules="formRule"
        :disabled="CLOId ? true : false"
      />

      <van-field
        v-model="form.consigneeContact.phoneNumber"
        :label="$t.orderManagement.phoneNumber"
        :placeholder="!CLOId ? $t.meta.input : ''"
        required
        :rules="formRule"
        :disabled="CLOId ? true : false"
      />

      <van-field
        v-model="form.consigneeContact.email"
        :label="$t.orderManagement.email"
        :placeholder="!CLOId ? $t.meta.input : ''"
        :required="LogisticsChannel == 1 ? true : false"
        :rules="LogisticsChannel == 1 ? formRule : null"
        :disabled="CLOId ? true : false"
      />

      <van-field
        clickable
        readonly
        :value="form.consigneeContact.countryName"
        :label="$t.meta.country"
        :placeholder="!CLOId ? $t.meta.select : ''"
        @click="onShowEmit('showOrderManagementDetailConsigneeCountry')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="form.consigneeContact.cityName"
        :label="$t.meta.city"
        :placeholder="!CLOId ? $t.meta.select : ''"
        @click="onShowEmit('showOrderManagementDetailConsigneeCity')"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.consigneeContact.zipCode"
        :label="$t.orderManagement.zipCode"
        :placeholder="!CLOId ? $t.meta.input : ''"
        required
        :rules="formRule"
        :disabled="CLOId ? true : false"
      />

      <van-field
        v-model="form.consigneeContact.address"
        :label="$t.orderManagement.detailAddress"
        :placeholder="!CLOId ? $t.meta.input : ''"
        required
        :rules="formRule"
        :disabled="CLOId ? true : false"
        type="textarea"
      />

      <div class="title">{{ $t.orderManagement.others }}</div>

      <div class="multi-table" v-if="form.items">
        <van-field name="stepper" :label="$t.orderManagement.itemsTitle">
          <template #input>
            <van-stepper
              :min="1"
              :value="form.items.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
              :disabled="CLOId ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.items" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)" v-if="!CLOId">
              <van-icon name="close" />
            </div>
          </div>

          <van-field
            v-model="item.skuName"
            :label="$t.orderManagement.skuName"
            :placeholder="!CLOId ? $t.meta.input : ''"
            required
            :rules="formRule"
            :disabled="CLOId ? true : false"
          />

          <van-field
            v-model="item.skuQty"
            @change="getTotalQuantity"
            :label="$t.orderManagement.skuQty"
            :placeholder="!CLOId ? $t.meta.input : ''"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
            required
            :rules="formRule"
            :disabled="CLOId ? true : false"
          />

          <van-field
            v-model="item.skuDeclaredValue"
            @change="getDeclaredValue"
            :label="$t.orderManagement.declareValue"
            :placeholder="!CLOId ? $t.meta.input : ''"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
            required
            :rules="formRule"
            :disabled="CLOId ? true : false"
          />

          <van-field
            v-model="item.customsCurrency"
            @change="getDeclaredValueCurrency"
            :label="$t.orderManagement.declareValueCurrency"
            :placeholder="!CLOId ? $t.meta.input : ''"
            required
            :rules="formRule"
            :disabled="CLOId ? true : false"
          />

          <van-field
            v-model="item.skuHsCode"
            :label="$t.orderManagement.hsCode"
            :placeholder="!CLOId ? $t.meta.input : ''"
            required
            :rules="formRule"
            :disabled="CLOId ? true : false"
          />

          <van-field
            v-model="item.weight"
            @change="getTotalWeight"
            :label="$t.orderManagement.weight + '(kg)'"
            :placeholder="!CLOId ? $t.meta.input : ''"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
            required
            :rules="formRule"
            :disabled="CLOId ? true : false"
          />

          <van-field
            v-model="item.volume"
            @change="getTotalVolume"
            :label="$t.orderManagement.volume + '(m3)'"
            :placeholder="!CLOId ? $t.meta.input : ''"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
            :disabled="CLOId ? true : false"
          />

          <van-field
            v-model="item.boxNumber"
            @change="getTotalBoxNumber"
            :label="$t.orderManagement.boxNumber"
            :placeholder="!CLOId ? $t.meta.input : ''"
            :disabled="CLOId ? true : false"
          />
        </div>

        <div class="title">{{ $t.orderManagement.declareTitle }}</div>

        <van-field
          v-model="form.declaredValue"
          :label="$t.orderManagement.declareValue"
          readonly
        />

        <van-field
          v-model="form.declaredValueCurrency"
          :label="$t.orderManagement.declareValueCurrency"
          readonly
        />

        <div class="title">{{ $t.orderManagement.itemsTotal }}</div>

        <van-field
          v-model="form.totalWeight"
          :label="$t.orderManagement.totalWeight"
          readonly
        />

        <van-field
          v-model="form.totalVolume"
          :label="$t.orderManagement.totalValue"
          readonly
        />

        <van-field
          v-model="form.totalBoxNumber"
          :label="$t.orderManagement.totalBoxNumber"
          readonly
        />

        <van-field
          v-model="form.totalQuantity"
          :label="$t.orderManagement.totalQuantity"
          readonly
        />
      </div>

      <div style="margin: 16px" v-if="!CLOId">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="datetime"
        :title="$t.orderManagement.naqel_ShippingDateTime"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showOrderManagementType" round position="bottom">
      <van-picker
        :title="$t.orderManagement.iMile_PackageGoodsType"
        show-toolbar
        :columns="packageGoodsTypeList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="typeConfirm"
        @cancel="showOrderManagementType = false"
      />
    </van-popup>

    <option-list
      event="showOrderManagementDetailFreight"
      :options="freightList"
      @onSelect="onSelectFreight"
    ></option-list>

    <option-list
      event="showOrderManagementDetailFreightDetail"
      :options="freightDetailList"
      @onSelect="onSelectService"
    ></option-list>

    <option-list
      event="showOrderManagementDetailShipperCountry"
      :options="countryList"
      @onSelect="onSelectShipperCountry"
    ></option-list>

    <option-list
      event="showOrderManagementDetailConsigneeCountry"
      :options="countryList"
      @onSelect="onSelectConsigneeCountry"
    ></option-list>

    <option-list
      event="showOrderManagementDetailShipperCity"
      :options="cityList"
      @onSelect="onSelectShipperCity"
    ></option-list>

    <option-list
      event="showOrderManagementDetailConsigneeCity"
      :options="cityList"
      @onSelect="onSelectConsigneeCity"
    ></option-list>

    <van-popup v-model="showTaxFeePicker" round position="bottom">
      <van-picker
        :title="$t.orderManagement.taxFeebearingParty"
        show-toolbar
        :columns="taxFeebearingPartyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="taxFeeConfirm"
        @cancel="showTaxFeePicker = false"
      />
    </van-popup>

    <van-popup v-model="showProductCategoryPicker" round position="bottom">
      <van-picker
        :title="$t.orderManagement.productCategory"
        show-toolbar
        :columns="productTaxList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="productCategoryConfirm"
        @cancel="showProductCategoryPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import OptionList from "@components/optionList/OptionList.vue";
import Vue from "vue";
import {
  Form,
  Field,
  Checkbox,
  Button,
  Icon,
  Image,
  Picker,
  Popup,
  Stepper,
  DatetimePicker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Checkbox)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Picker)
  .use(Popup)
  .use(Stepper)
  .use(DatetimePicker);

export default {
  name: "orderManagementDetail",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      language: localStorage.getItem("requestLanguage") || "auto",
      CLOId: null,
      TransportationService: "",
      LogisticsChannel: null,
      LogisticsChannelStr: "",
      form: {
        fpIdStr: "",
        fpId: null,
        fpdIdStr: "",
        fpdId: null,
        TaxFeebearingParty: null,
        TaxFeebearingPartyStr: "",
        PTId: null,
        PTIdStr: "",
        declaredValue: 0,
        declaredValueCurrency: "",
        //Naqel
        Naqel_ShippingDateTime: "",
        Naqel_DescriptionOfGoods: "",
        Naqel_NumberOfPieces: "",
        //iMile
        iMile_PackageTotalVolume: "",
        iMile_PackageGrossWeight: "",
        iMile_PackageTotalCount: "",
        iMile_PackageGoodsType: "",
        shipperContact: {
          companyName: "",
          contacts: "",
          phoneNumber: "",
          email: "",
          countryName: "",
          countryId: null,
          cityName: "",
          cityId: null,
          address: "",
          zipCode: "",
        },
        consigneeContact: {
          companyName: "",
          contacts: "",
          phoneNumber: "",
          email: "",
          countryName: "",
          countryId: null,
          cityName: "",
          cityId: null,
          address: "",
          zipCode: "",
        },
        items: [
          {
            skuName: "",
            skuQty: null,
            skuDeclaredValue: null,
            customsCurrency: "",
            skuHsCode: "",
            weight: null,
            volume: null,
            boxNumber: null,
          },
        ],
        totalWeight: 0,
        totalVolume: 0,
        totalBoxNumber: 0,
        totalQuantity: 0,
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      freightList: [],
      showOrderManagementDetailFreight: false,
      freightDetailList: [],
      showOrderManagementDetailFreightDetail: false,
      countryList: [],
      showOrderManagementDetailShipperCountry: false,
      showOrderManagementDetailConsigneeCountry: false,
      cityList: [],
      showOrderManagementDetailShipperCity: false,
      showOrderManagementDetailConsigneeCity: false,
      packageGoodsTypeList: ["Normal", "Sensitive", "Battery", "PureBattery"],
      showOrderManagementType: false,
      //日期
      selectDate: new Date(),
      showTimePicker: false,
      currentDate: "",
      //tax
      showProductCategoryPicker: false,
      productTaxList: [],
      showTaxFeePicker: false,
      taxFeebearingPartyList: [
        {
          text: this.$t.orderManagement.shipper,
          value: 1,
        },
        {
          text: this.$t.orderManagement.consignee,
          value: 2,
        },
      ],
    };
  },
  created() {
    const { CLOId, FPId, FPDId } = this.$route.query;
    if (CLOId) {
      this.CLOId = CLOId;
      this.getOptions().then((success) => {
        if (success) {
          this.getCustomerLogisticsOrderByCLOId();
        }
      });
    } else if (FPId || FPDId) {
      this.getOptions().then((success) => {
        if (success) {
          this.form.fpId = FPId;
          var item1 = this.freightList.find((f) => f.value == FPId);
          this.form.fpIdStr = item1 ? item1.text : "";
          this.loadFreightPriceInfo().then((success) => {
            if (success) {
              this.form.fpdId = FPDId;
              var item2 = (this.form.fpdIdStr = this.freightDetailList.find(
                (f) => f.value == FPDId
              ));
              this.form.fpdIdStr = item2 ? item2.text : "";
              this.getLogisticsChannel(this.form.fpdId);
            }
          });
        }
      });
    } else {
      this.getOptions();
    }
  },
  methods: {
    getLogisticsChannel(value) {
      var LogisticsChannel = null;
      var LogisticsChannelStr = "";
      for (var freight of this.freightDetailList) {
        if (freight.value == value) {
          LogisticsChannel = freight.LogisticsChannel;
          if (LogisticsChannel == 1) {
            LogisticsChannelStr = "Naqel";
          } else if (LogisticsChannel == 2) {
            LogisticsChannelStr = "iMile";
          } else {
            LogisticsChannelStr = this.$t.orderManagement.none;
          }
          //产品类别
          if (freight.ProductTaxList && freight.ProductTaxList.length > 0) {
            var productTaxList = [];
            freight.ProductTaxList.forEach((item) => {
              let data = {
                text: item.ProductCategory,
                value: item.PTId,
              };
              productTaxList.push(data);
            });
            this.productTaxList = productTaxList;
          } else {
            this.productTaxList = [];
          }
        }
      }
      this.LogisticsChannel = LogisticsChannel;
      this.LogisticsChannelStr = LogisticsChannelStr;
    },
    productCategoryConfirm(item) {
      this.form.PTIdStr = item.text;
      this.form.PTId = item.value;
      this.showProductCategoryPicker = false;
    },
    taxFeeConfirm(item) {
      this.form.TaxFeebearingPartyStr = item.text;
      this.form.TaxFeebearingParty = item.value;
      this.showTaxFeePicker = false;
    },
    typeConfirm(val) {
      if (!val) {
        return;
      }
      this.form.iMile_PackageGoodsType = val;
      this.showOrderManagementType = false;
    },
    onSelectFreight(item) {
      this.form.fpIdStr = item.text;
      this.form.fpId = item.value;
      this.form.fpdIdStr = "";
      this.form.fpdId = null;
      this.LogisticsChannelStr = "";
      this.LogisticsChannel = null;
      this.loadFreightPriceInfo();
    },
    onSelectService(item) {
      this.form.fpdIdStr = item.text;
      this.form.fpdId = item.value;
      if (item.rightText == "Naqel") {
        this.LogisticsChannel = 1;
      } else if (item.rightText == "iMile") {
        this.LogisticsChannel = 2;
      } else {
        this.LogisticsChannel = 0;
      }
      this.getLogisticsChannel(this.form.fpdId);
    },
    onSelectShipperCountry(item) {
      this.form.shipperContact.countryName = item.text;
      this.form.shipperContact.countryId = item.value;
      this.getCities(item.value, "shipper", true);
      this.$forceUpdate();
    },
    onSelectConsigneeCountry(item) {
      this.form.consigneeContact.countryName = item.text;
      this.form.consigneeContact.countryId = item.value;
      this.getCities(item.value, "consignee", true);
      this.$forceUpdate();
    },
    onSelectShipperCity(item) {
      this.form.shipperContact.cityName = item.text;
      this.form.shipperContact.cityId = item.value;
      this.$forceUpdate();
    },
    onSelectConsigneeCity(item) {
      this.form.consigneeContact.cityName = item.text;
      this.form.consigneeContact.cityId = item.value;
      this.$forceUpdate();
    },
    getCities(countryId, type, isReset) {
      for (let country of this.countryList) {
        if (country.value == countryId) {
          this.cityList = country.cityList;
          if (type == "shipper") {
            if (isReset) {
              this.form.shipperContact.cityName = "";
              this.form.shipperContact.cityId = null;
            }
          }
          if (type == "consignee") {
            if (isReset) {
              this.form.consigneeContact.cityName = "";
              this.form.consigneeContact.cityId = null;
            }
          }
        }
      }
    },
    handleDelByIndex(index) {
      if (this.form.items.length > 0) {
        this.form.items.splice(index, 1);
      }
      this.getAllStatistics();
    },
    handleDel() {
      if (this.form.items.length > 0) {
        this.form.items.pop();
      }
      this.getAllStatistics();
    },
    handleAdd() {
      this.form.items.push({
        skuName: "",
        skuQty: null,
        skuDeclaredValue: null,
        customsCurrency: "",
        skuHsCode: "",
        weight: null,
        volume: null,
        boxNumber: null,
      });
      this.getAllStatistics();
    },
    onShowEmit(emit) {
      if (this.CLOId) {
        return;
      }
      this.$bus.$emit(emit, true);
    },
    pickerShow(pickerName) {
      if (this.CLOId) {
        return;
      }
      this[pickerName] = true;
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getFreightPriceListByPage(),
          this.getTakeDeliveryCountryCityList(),
        ])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getFreightPriceListByPage() {
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .getFreightPriceListByPage()
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.CountryName,
                value: item.FPId,
              };
              result.push(data);
            });
            this.freightList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getTakeDeliveryCountryCityList() {
      return new Promise((resolve) => {
        var param = {
          BusinessType: 5,
        };
        this.$api.myCustomer
          .getTakeDeliveryCountryCityList(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              var cityList = [];
              if (item.CityList) {
                for (var city of item.CityList) {
                  cityList.push({
                    text: city.City_cn + "," + city.City_en,
                    value: city.CityId,
                  });
                }
              }
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
                cityList: cityList,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    loadFreightPriceInfo() {
      this.$commonMethod.showLoading();
      var param = {
        FPId: this.form.fpId,
      };
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .loadFreightPriceInfo(param)
          .then((res) => {
            var result = [];
            var data = res.data;
            if (data && data.DetailList) {
              data.DetailList.forEach((item) => {
                var channel = "";
                if (item.LogisticsChannel == 1) {
                  channel = "Naqel";
                }
                if (item.LogisticsChannel == 2) {
                  channel = "iMile";
                }
                let data = {
                  text: this.language == "zh" ? item.CargoCategory : item.CargoCategoryEn,
                  value: item.FPDId,
                  rightText: channel,
                  LogisticsChannel: item.LogisticsChannel,
                  ProductTaxList: item.ProductTaxList,
                };
                result.push(data);
              });
            }
            this.freightDetailList = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCustomerLogisticsOrderByCLOId() {
      this.$commonMethod.showLoading();
      var param = {
        CLOId: this.CLOId,
      };
      return new Promise((resolve) => {
        this.$api.orderManagement
          .getCustomerLogisticsOrderByCLOId(param)
          .then((res) => {
            var data = res.data;
            this.form.declaredValue = data.DeclaredValue;
            this.form.declaredValueCurrency = data.DeclaredValueCurrency;
            this.TransportationService = data.TransportationService;
            if (data.LogisticsChannel == 1) {
              this.LogisticsChannel = 1;
              this.LogisticsChannelStr = "Naqel";
            } else if (data.LogisticsChannel == 2) {
              this.LogisticsChannel = 2;
              this.LogisticsChannelStr = "iMile";
            } else {
              this.LogisticsChannel = 0;
              this.LogisticsChannelStr = this.$t.orderManagement.none;
            }
            this.form.Naqel_ShippingDateTime = data.Naqel_ShippingDateTime;
            this.form.Naqel_DescriptionOfGoods = data.Naqel_DescriptionOfGoods;
            this.form.Naqel_NumberOfPieces = data.Naqel_NumberOfPieces;
            this.form.iMile_PackageTotalVolume = data.iMile_PackageTotalVolume;
            this.form.iMile_PackageGrossWeight = data.iMile_PackageGrossWeight;
            this.form.iMile_PackageTotalCount = data.iMile_PackageTotalCount;
            this.form.iMile_PackageGoodsType = data.iMile_PackageGoodsType;
            this.getCities(data.ShipperContact.CountryId, "shipper");
            var country1 = this.countryList.find(
              (c) => c.value == data.ShipperContact.CountryId
            );
            var city1 = this.cityList.find((c) => c.value == data.ShipperContact.CityId);
            this.form.shipperContact = {
              companyName: data.ShipperContact.CompanyName,
              contacts: data.ShipperContact.Contacts,
              phoneNumber: data.ShipperContact.PhoneNumber,
              email: data.ShipperContact.Email,
              countryName: country1 ? country1.text : "",
              countryId: data.ShipperContact.CountryId,
              cityName: city1 ? city1.text : "",
              cityId: data.ShipperContact.CityId,
              address: data.ShipperContact.Address,
              zipCode: data.ShipperContact.ZipCode,
            };
            this.getCities(data.ConsigneeContact.CountryId, "consignee");
            var country2 = this.countryList.find(
              (c) => c.value == data.ConsigneeContact.CountryId
            );
            var city2 = this.cityList.find(
              (c) => c.value == data.ConsigneeContact.CityId
            );
            this.form.consigneeContact = {
              companyName: data.ConsigneeContact.CompanyName,
              contacts: data.ConsigneeContact.Contacts,
              phoneNumber: data.ConsigneeContact.PhoneNumber,
              email: data.ConsigneeContact.Email,
              countryName: country2 ? country2.text : "",
              countryId: data.ConsigneeContact.CountryId,
              cityName: city2 ? city2.text : "",
              cityId: data.ConsigneeContact.CityId,
              address: data.ConsigneeContact.Address,
              zipCode: data.ConsigneeContact.ZipCode,
            };
            var items = [];
            for (var item of data.Items) {
              items.push({
                skuName: item.SkuName,
                skuQty: item.SkuQty,
                skuDeclaredValue: item.SkuDeclaredValue,
                customsCurrency: item.CustomsCurrency,
                skuHsCode: item.SkuHsCode,
                weight: item.Weight,
                volume: item.Volume,
                boxNumber: item.BoxNumber,
              });
            }
            this.form.items = items;
            this.form.totalWeight = data.TotalWeight;
            this.form.totalVolume = data.TotalVolume;
            this.form.totalBoxNumber = data.TotalBoxNumber;
            this.form.totalQuantity = data.TotalQuantity;
            this.$commonMethod.fieldRefresh(".orderManagementDetail");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      this.$api.orderManagement
        .createLogisticsOrder(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    showTimeDate() {
      if (this.CLOId) {
        return;
      }
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        var hour = value.getHours() < 10 ? "0" + value.getHours() : value.getHours();
        var minute =
          value.getMinutes() < 10 ? "0" + value.getMinutes() : value.getMinutes();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date + " " + hour + ":" + minute;
      };
      this.form.Naqel_ShippingDateTime = formatDate(date);
      this.showTimePicker = false;
    },
    getDeclaredValue() {
      let num = 0;
      this.form.items.forEach((item) => (num = Number(item["skuDeclaredValue"]) + num));
      this.form["declaredValue"] = num.toFixed(3);
    },
    getDeclaredValueCurrency() {
      if (this.form.items.length) {
        if (this.form.items[0] && this.form.items[0].customsCurrency) {
          this.form.declaredValueCurrency = this.form.items[0].customsCurrency;
        } else {
          this.form.declaredValueCurrency = "";
        }
      }
    },
    getAllStatistics() {
      this.getTotalWeight();
      this.getTotalVolume();
      this.getTotalBoxNumber();
      this.getTotalQuantity();
    },
    getTotalWeight() {
      let num = 0;
      this.form.items.forEach((item) => (num = Number(item["weight"]) + num));
      this.form["totalWeight"] = num.toFixed(3);
    },
    getTotalVolume() {
      let num = 0;
      this.form.items.forEach((item) => (num = Number(item["volume"]) + num));
      this.form["totalVolume"] = num.toFixed(3);
    },
    getTotalBoxNumber() {
      let num = 0;
      this.form.items.forEach((item) => (num = Number(item["boxNumber"]) + num));
      this.form["totalBoxNumber"] = num.toFixed(3);
    },
    getTotalQuantity() {
      let num = 0;
      this.form.items.forEach((item) => (num = Number(item["skuQty"]) + num));
      this.form["totalQuantity"] = num.toFixed(3);
    },
  },
};
</script>
<style lang="scss" scoped>
.orderManagementDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }

  .custom-field {
    font-size: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;

    .custom-field-label {
      width: 120px;
      font-size: 14px;
      margin-right: 12px;
      color: #323233;
      display: inline-block;
      vertical-align: middle;
    }

    .custom-field-value {
      width: 50%;
      color: #323233;
      display: inline-block;
      vertical-align: middle;
    }
  }

  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  .avatarImg {
    width: 50px;
    height: 50px;
  }

  .orderManagementDetail-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;

    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }

    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
      display: inline-flex;
    }
  }

  .custom-date {
    background: #ffffff;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;

    .date-btn1 {
      width: 33%;
      display: inline-block;
      margin-right: 5%;
      font-size: 14px;
      color: #646566;

      .date-require {
        color: red;
        position: absolute;
        left: 8px;
      }
    }

    .date-btn2 {
      width: 62%;
      display: inline-block;
      font-size: 14px;

      .value {
        color: #323233;
      }

      .placeholder {
        color: #c3c3c3;
      }
    }
  }

  .multi-table {
    .multi-table-header {
      padding: 10px 15px;

      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }

      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
}
</style>
